export function createdInQuickbooks(invoice) {
  // This invoice came from QuickBooks (wasn't created in LeanLaw)
  if (invoice.accounting && invoice.groups.length === 1 && invoice.groups[0].lineItems.length === 1) {
    const item = invoice.groups[0].lineItems[0];
    return item.amount && !item.description;
  }
  return false;
}
export const generateRandomID = function () {
  return Math.floor(Math.random() * 0xFFFFFFFF).toString(16);
};
const hash = function (s) {
  /* Simple hash function. */
  let a = 1;
  let c = 0;
  let h;
  let o;
  if (s) {
    a = 0;
    /*jshint plusplus:false bitwise:false*/
    for (h = s.length - 1; h >= 0; h--) {
      o = s.charCodeAt(h);
      a = (a << 6 & 268435455) + o + (o << 14);
      c = a & 266338304;
      a = c !== 0 ? a ^ c >> 21 : a;
    }
  }
  return String(a);
};
export const hashArrayObjects = function (objects) {
  return objects.map(e => {
    // Never hash object with its old hash
    if (e.hasOwnProperty("_objectHash")) delete e._objectHash;
    const entrySignature = JSON.stringify(e);
    return Object.assign({
      _objectHash: hash(entrySignature)
    }, e);
  });
};